import useResolution from '@hooks/useResolution'
import { useEffect, useRef, useState } from 'react'
import ReactConfetti from 'react-confetti'
import { createPortal } from 'react-dom'

type Props = {
  shouldShowConfetti: boolean
  className?: string
  height?: number
  width?: number
  recycle?: boolean
}

const Confetti = ({
  shouldShowConfetti,
  className,
  height,
  width,
  recycle = true,
}: Props) => {
  const [mounted, setMounted] = useState(false)
  const rootElement = useRef<HTMLElement>(null)
  const { dimensions } = useResolution()

  useEffect(() => {
    rootElement.current = document.getElementById('__next')
    setMounted(true)
  }, [])

  if (!mounted) return null

  return createPortal(
    <div className="absolute top-0 z-40">
      {typeof window !== 'undefined' && shouldShowConfetti && (
        <ReactConfetti
          className={className}
          height={height || dimensions?.height}
          width={width || dimensions?.width}
          style={{ zIndex: 12 }}
          recycle={recycle}
        />
      )}
    </div>,
    rootElement.current
  )
}

export default Confetti
